import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { ConfigProvider } from '../../providers/config/config'

import { CadastalType, HousingUnit } from '../../models/models'

@Injectable()
export class HousingUnitProvider {
	constructor(
		public config: ConfigProvider,
		public http: HttpClient
	) {
	}

	public destroy(housingUnit: HousingUnit): Promise<boolean> {
		let request = this.http.post<boolean>(ConfigProvider.HOST + "/housing-unit/" + housingUnit.id + "/destroy", { confirm: true })
		let promise = request.toPromise()
		promise.then((success: boolean) => {
			if(success) {
				console.log("Unità abitativa eliminata")
			} else {
				console.log("Errore eliminando l'unità abitativa")
			}
		}).catch((error: any) => {
			console.error("Errore eliminando l'unità abitativa:", error)
		})
		return promise
	}

	/*
	Rilegge le unità immobliari del condominio
	*/
	public getByCondominiumId(id: number): Promise<Array<HousingUnit>> {
		let request = this.http.get<Array<HousingUnit>>(ConfigProvider.HOST + "/housing-unit/condominium/" + id)
		let promise = request.toPromise()
		promise.then((units: Array<HousingUnit>) => {
			console.log("Elenco delle unità immobiliari del condominio recuperato: ", units)
		}).catch((error: any) => {
			console.error("Errore recuperando le unità immobiliari del condomninio:", error)
		})
		return promise
	}

	public getById(id: number, loads = []): Promise<HousingUnit> {
		let httpParams: HttpParams = new HttpParams()

		//aggiunge eventuali relazioni da caricare

		if(loads && loads.length > 0) {
			for(let load of loads) {
				httpParams = httpParams.append('load[]', load)
			}
		}


		let self = this
		let request = this.http.get<HousingUnit>(ConfigProvider.HOST + "/housing-unit/" + id, { params: httpParams })
		let promise = request.toPromise()
		promise.then((unit: HousingUnit) => {
			console.log("Unità abitativa recuperata: ", unit)
			self.init(unit)
		}).catch((error: any) => {
			console.error("Errore recuperando l'unità abitativa':", error)
		})
		return promise
	}

	public getByUserId(id: number, loads = [], httpParams: HttpParams = new HttpParams()): Promise<Array<HousingUnit>> {
		//aggiunge eventuali relazioni da caricare

		if(loads && loads.length > 0) {
			for(let load of loads) {
				httpParams = httpParams.append('load[]', load)
			}
		}


		let params = {}
		if(httpParams) {
			params['params'] = httpParams
		}

		let self = this
		let request = this.http.get<Array<HousingUnit>>(ConfigProvider.HOST + "/housing-unit/user/" + id, { params: httpParams })
		let promise = request.toPromise()
		promise.then(
			(units: Array<HousingUnit>) => {
				console.log("Elenco unità immobiliari utente recuperato: ", units)
				for(let unit of units) {
					self.init(unit)
				}
			}).catch((error: any) => {
				console.error("Errore recuperando le unità immobiliari dell'utente:", error)
			})
		return promise
	}

	/**
	Ordina un vettore di unità immobiliari con un criterio univoco adatto alle UI
	*/
	public static sort(units: HousingUnit[], clone: boolean = true): HousingUnit[] {
		if(clone) {
			units = units.slice()//clona l'array
		}
		return units.sort((a: HousingUnit, b: HousingUnit): number => {
			let compare = (c: string, d: string) => {//compara 2 valori che possono essere nulli o misti numero e testo
				/*
				CASI CON UNO DEI DUE VUOTO
				*/
				if(!c) {//c vuoto
					return d ? -1 : 0//d pieno -1, entrambi vuoti 0
				} else if(!d) {//c pieno d vuoto 1
					return 1//c>d
				}
				//da qui entrambi non vuoti

				let cInt = parseInt(c)
				let dInt = parseInt(d)
				/*
				CASI CON UNO DEI DUE 0 o NaN
				*/
				if(!cInt) {//c NaN o 0
					return dInt ? -1 : 0//cInt 0 NaN -1 o entrambi 0 NaN 0
				} else if(!dInt) {//dInt NaN o 0
					return 1//c numero > dInt NaN o 0
				}
				//da qui entrambi iniziano con valore numerico

				if(cInt == dInt) {//stesso valore numerico: compara le stringhe
					c = c.toLowerCase()
					d = d.toLowerCase()
					return c < d ? -1 : c > d ? 1 : 0
				}

				/**
				Caso solo numeri
				*/
				return cInt - dInt//se cInt < dInt <0, se pari 0, se cInt>dInt >0
			}


			let result = null
			if((result = compare(a.internal, b.internal)) !== 0) {
				return result
			}
			if((result = compare(a.stair, b.stair)) !== 0) {
				return result
			}
			if((result = compare(a.floor, b.floor)) !== 0) {
				return result
			}
			if((result = compare(a.label, b.label)) !== 0) {
				return result
			}
			//non ha trovato differenze
			return 0
		})
	}

	public store(housingUnit: HousingUnit): Promise<HousingUnit> {
		let request = this.http.post<HousingUnit>(ConfigProvider.HOST + "/housing-unit/store/" + housingUnit.condominium.id, this.prepare(housingUnit))
		let promise = request.toPromise()
		promise.then((housingUnit: HousingUnit) => {
			console.log("Unità abitativa creata: ", housingUnit)
		}).catch((error: any) => {
			console.error("Errore creando l'unità abitativa:", error)
		})
		return promise
	}

	public update(housingUnit: HousingUnit): Promise<HousingUnit> {

		let request = this.http.post<HousingUnit>(ConfigProvider.HOST + "/housing-unit/" + housingUnit.id + "/update", this.prepare(housingUnit))
		let promise = request.toPromise()
		promise.then((housingUnit: HousingUnit) => {
			console.log("Unità abitativa aggiornata: ", housingUnit)
		}).catch((error: any) => {
			console.error("Errore aggiornando l'unità abitativa:", error)
		})
		return promise
	}

	public init(housingUnit: HousingUnit) {
		/*
		Raggruppa owners e residents, se non già inizializzati e ha i dati degli utenti
		*/
		if(housingUnit.users) {
			if(!housingUnit.residents || housingUnit.residents.length == 0) {
				housingUnit.residents = []
				for(let i in housingUnit.users) {
					let u = housingUnit.users[i]
					if(u.pivot) {
						if(u.pivot.is_resident == 1) {
							housingUnit.residents.push(u)
						}
					}
				}
			}
			if(!housingUnit.owners || housingUnit.owners.length == 0) {
				housingUnit.owners = []
				for(let i in housingUnit.users) {
					let u = housingUnit.users[i]
					if(u.pivot) {
						if(u.pivot.is_owner == 1) {
							housingUnit.owners.push(u)
						}
					}
				}
			}
			//fix errore con valore nullo
			if(!housingUnit.cadastal_type) {
				housingUnit.cadastal_type = CadastalType.NONE
			}
		}
	}

	/**
	 * prepara la housingunit per invio al server
	 */
	public prepare(housingUnit: HousingUnit) {
		if(housingUnit.cadastal_type == CadastalType.NONE) {
			housingUnit.cadastal_type = null
		}
		return housingUnit
	}
}



// WEBPACK FOOTER //
// ./src/providers/housing-unit/housing-unit.ts